import { render, staticRenderFns } from "./customer-add-or-update.vue?vue&type=template&id=7903a555&scoped=true"
import script from "./customer-add-or-update.vue?vue&type=script&lang=js"
export * from "./customer-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./customer-add-or-update.vue?vue&type=style&index=0&id=7903a555&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7903a555",
  null
  
)

export default component.exports